import React, { FC } from 'react'
import OrganizationDetails from './organization-details/OrganizationDetails'
import { useProfile } from '../../../repositories/profile/profile.repository'
import { useParams } from 'react-router-dom'
import { useProfileApplications } from '../../../repositories/profile/profile-applications.repository'
import { useApplications } from '../../../context/ApplicationsContext'
import DetailItem from './DetailItem'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../../contexts/AuthContext'

const Details: FC = () => {
  const { org, id } = useParams()
  const { userId } = useAuth()
  const { data: profile } = useProfile({ id })
  const { data: applications } = useProfileApplications({ organization: org, id })
  const { profileApps } = useApplications()
  const { t } = useTranslation()

  function checkShouldEditUser() {
    //user can't edit himself
    if (userId === id) return false
    //admin can't edit or deactivate org admin
    const loggedInUserRole = profileApps?.find?.((el) => el.id === 's-organization')?.roles?.[0]?.name
    const userProfileRole = applications?.applications?.find((el) => el.id === 's-organization')?.roles?.[0]?.name
    if (loggedInUserRole === 'admin' && userProfileRole === 'org-admin') {
      return false
    } else return true
  }

  // TODO implement contact details
  // backend doesn't return contact details for now because it's stored in Ory identity provider
  // and they need to implement it in the future
  return (
    <div className='grid grid-cols-2 w-full lg:!w-5/6 gap-x-6 pl-6 pr-7 '>
      <div className='flex flex-col gap-y-6'>
        <h1 className='text-lg font-medium text-[#262A38]'>{t('Profile.about')}</h1>
        <DetailItem label={t('Profile.firstName')} value={profile?.data.firstName ?? ''} />
        <DetailItem label={t('Profile.lastName')} value={profile?.data.lastName ?? ''} />
      </div>
      <OrganizationDetails
        apps={applications?.applications ?? []}
        status={applications?.status ?? ''}
        groups={applications?.groups ?? []}
        units={applications?.units ?? []}
        readonly={!checkShouldEditUser()}
      />
    </div>
  )
}

export default Details
